module.exports = __webpack_public_path__ + "static/media/1POLICY29.8d64dc0d.jpg";